import React from "react";
import SearchBar from "@/shared/components/ui/SearchBar/SearchBar";
import PaginationInfo from "@/shared/components/ui/Pagination/PaginationInfo";
import { PrimaryButton } from "@/shared/components/ui/Button/PrimaryButton";
import SecondaryButton from "@/shared/components/ui/Button/SecondaryButton";
import { Trash2 } from "lucide-react";
import { useMainStore } from "@/stores/index";

const CampaignLeadsHeader = ({
  searchValue,
  setSearchValue,
  onSearchChange,
  onAddLeads,
  selectedLeads,
  onBulkDelete,
  onClearSelection,
  currentPage = 1,
  rowsPerPage = 15,
  totalCount,
}) => {
  const sidebarExpanded = useMainStore((state) => state.sidebarExpanded);
  return (
    <div className="flex justify-between items-center w-full flex-wrap gap-2">
      <div className="flex gap-1.5 w-full items-center flex-1 min-w-0">
        <SearchBar
          value={searchValue}
          setFilterValue={setSearchValue}
          onChange={onSearchChange}
          placeholder="Search leads..."
          className={`w-full  ${sidebarExpanded ? " max-w-[220px]" : "max-w-[280px]"} duration-300 transition-all`}
        />
        <PaginationInfo
          totalCount={totalCount}
          currentPage={currentPage}
          rowsPerPage={rowsPerPage}
          itemName="lead"
          suffixText="total added by you"
          className="whitespace-nowrap"
        />
      </div>
      {selectedLeads?.length > 0 && (
        <div className="flex gap-2 items-center">
          <SecondaryButton
            title={
              selectedLeads.length > 1
                ? `Delete (${selectedLeads.length})`
                : "Delete"
            }
            icon={<Trash2 size={16} className="text-error-500" />}
            onClick={onBulkDelete}
            className="shadow-none border-error-500 text-error-500"
          />
          <SecondaryButton
            title="Clear Selection"
            onClick={onClearSelection}
            className="shadow-none"
          />
        </div>
      )}
      <div className="w-fit">
        <PrimaryButton onClick={onAddLeads}>Add Leads</PrimaryButton>
      </div>
    </div>
  );
};

export default CampaignLeadsHeader;
